<template>
  <div>
    <CCard class="mob-pd-0px">
      <CCardHeader class="grey-header d-flex mob-flex-column ai-center">
        <CRow class="flex-flow-column">
          <CCol>
            <strong>{{ $t("fareUpload.title") }}</strong>
          </CCol>

          <p class="desc">{{ $t("fareUpload.desc") }}</p>
        </CRow>
        <CButton
          @click="navigateToFareUploadNew(null)"
          size="sm"
          color="success"
          class="ml-auto btn-lit-blue mob-w100"
        >{{ $t("fareUpload.addFareUpload") }}</CButton>
        <!-- <div class="generate-ex-btn" @click="toggleJsonExcelModal">
          <img src="@imgPath/img/svg/icons/excle-icon.svg" alt />
        </div> -->
      </CCardHeader>

      <CCardBody class="user-manage-table pt-0px p-0 m-0 ">
             <br>
          <div class="d-flex"  v-if="GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode">
          <h3>{{$t("contract.contractName")+' : '}}</h3>  <h3 class="text-transform-uppercase"> {{GET_SELECTED_CONTRACT&&GET_SELECTED_CONTRACT.contractcode}}</h3>
           </div>

        <CCol id="user-manage-table" class="usersTable border-grey manage-user-table m-0">
     
            <cTable
              :fields="lsFlightFareFields"
              :items="lsFlightFare"
              caption="User"
              pagination
              column-filter
                @update:column-filter-value="saveFilterValue"
              items-per-page-select
              :items-per-page="flightFareTableWatchList.itemsPerPage"
              hover
              :sorter="{  resetable: true }"
              class="table-striped"
              :sorterValue="{ column: 'from', asc: 'true' }"
              @filtered-items-change="getFilteredFlightFareCount"
              @page-change="onPageChange"
              @pagination-change="onPaginationChange"
                        :loading="isLoading"
                          :tableWatchList="flightFareTableWatchList"
             @getFields="onSaveColumns"
             :manageColumn="true"
                                    :paginationLenOption="true"

            >
              <!-- <template #over-table>
                <cManageColumns v-if="lsFlightFareFields&&lsFlightFareFields.length>0" :lsFields="lsFlightFareFields" @getFields="onSaveColumns"/>
                <cPaginationLenOption :paginationWatchLs="flightFareTableWatchList" />
                
              </template> -->
              <template #depcode="{item}">
                <td class="py-2">
                  <div>{{ item.depcode?item.depcode:'' }}</div>
                </td>
              </template>
              <template #arrcode="{item}">
                <td class="py-2">
                  <div>{{ item.arrcode?item.arrcode:'' }}</div>
                </td>
              </template>
              <template #fare_type="{item}">
                <td class="py-2">
                  <div>{{ item.fare_type?item.fare_type:'' }}</div>
                </td>
              </template>
              <template #currency="{item}">
                <td class="py-2">
                  <div>{{ item.currency?item.currency:'' }}</div>
                </td>
              </template>
              <template #basefare_amount="{item}">
                <td class="py-2">
                  <div>{{ item.basefare_amount|formatNumber(item.currency) }}</div>
                </td>
              </template>
              <template #pax_type="{item}">
                <td class="py-2">
                  <div>{{ item.pax_type?item.pax_type:'' }}</div>
                </td>
              </template>
              <template #booking_class="{item}">
                <td class="py-2">
                  <div>{{ item.booking_class?item.booking_class:'' }}</div>
                </td>
              </template>
                <template #cabin_type="{item}">
                <td class="py-2">
                  <div>{{ item.cabin_type?item.cabin_type:'' }}</div>
                </td>
              </template>
              <template #max_seats="{item}">
                <td class="py-2">
                  <div>{{ item.max_seats }}</div>
                </td>
              </template>
               <template #ruleCode="{item}">
                <td class="py-2">
                  <div>{{ item.ruleCode?item.ruleCode:'' }}</div>
                </td>
              </template>
               <template #airline_farebasis_code="{item}">
                <td class="py-2">
                  <div>{{ item.airline_farebasis_code?item.airline_farebasis_code:'' }}</div>
                </td>
              </template>

              <template #no-items-view>
                <div class="text-center my-5">
                  <h2>{{isLoading?"":$t("fareUpload.noFaresFound") }}</h2>
                </div>
              </template>

              <template #actions="{item}">
                <td class="py-2 filled-icon-wrap">
                 
                  <div class="right-align row justify-content-between m-0 w-100">
                    <CCol md="6" sm="6"  class="d-flex justify-content-center">
                      <div  @click.stop="navigateToFareUploadNew(item)"
                            v-if="permission&&permission.canEdit"
                            class="edit-icon"
                            color="info removewrap"
                            v-c-tooltip.hover="{ content: $t('fareUpload.editTooltip') , active:false }"
                      >
                        <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="512pt"
                                viewBox="0 0 512 512"
                                width="512pt"
                                style="fill:#3c4b64;"
                        >
                          <path
                                  d="m368 511.957031h-309.332031c-32.363281 0-58.667969-26.304687-58.667969-58.667969v-309.332031c0-32.363281 26.304688-58.667969 58.667969-58.667969h181.332031c8.832031 0 16 7.167969 16 16 0 8.832032-7.167969 16-16 16h-181.332031c-14.699219 0-26.667969 11.96875-26.667969 26.667969v309.332031c0 14.699219 11.96875 26.667969 26.667969 26.667969h309.332031c14.699219 0 26.667969-11.96875 26.667969-26.667969v-181.332031c0-8.832031 7.167969-16 16-16s16 7.148438 16 16v181.332031c0 32.363282-26.304688 58.667969-58.667969 58.667969zm0 0"
                          />
                          <path
                                  d="m187.136719 340.820312c-4.203125 0-8.300781-1.664062-11.308594-4.691406-3.796875-3.777344-5.417969-9.21875-4.371094-14.445312l15.082031-75.433594c.617188-3.113281 2.152344-5.953125 4.371094-8.171875l220.953125-220.925781c22.867188-22.871094 60.074219-22.871094 82.964844 0 11.070313 11.070312 17.171875 25.792968 17.171875 41.472656s-6.101562 30.398438-17.195312 41.472656l-220.925782 220.949219c-2.21875 2.238281-5.078125 3.753906-8.171875 4.371094l-75.414062 15.082031c-1.046875.214844-2.113281.320312-3.15625.320312zm75.433593-31.082031h.214844zm-45.609374-52.457031-9.410157 47.144531 47.125-9.429687 217.515625-217.511719c5.035156-5.058594 7.808594-11.734375 7.808594-18.859375s-2.773438-13.804688-7.808594-18.859375c-10.367187-10.390625-27.285156-10.390625-37.714844 0zm0 0"
                          />
                          <path
                                  d="m453.332031 134.976562c-4.09375 0-8.191406-1.558593-11.304687-4.695312l-60.332032-60.351562c-6.25-6.25-6.25-16.382813 0-22.632813s16.382813-6.25 22.636719 0l60.328125 60.351563c6.25 6.25 6.25 16.382812 0 22.632812-3.136718 3.117188-7.230468 4.695312-11.328125 4.695312zm0 0"
                          />
                        </svg>
                      </div>
                    </CCol>
                    <CCol md="6" sm="6" class="d-flex justify-content-center">
                      <div
                              v-if="permission&&permission.canDelete"
                              @click.stop="showDeleteFareModal(item)"
                              class="c-red"
                              v-c-tooltip.hover="{ content: $t('fareUpload.deleteToolTip') , active:false }"
                      >
                        <CIcon color="#cd0606" name="cil-trash" size="lg" />
                      </div>
                    </CCol>




                  </div>
                </td>
              </template>
                                           <template #actions-filter>
                        <td   style="border-top: 0px;
    height: 100%;">
                            <div @click="clearAllFilters()" class="clear-filter-btn">
                                <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        version="1.1"
                                        id="Capa_1"
                                        x="0px"
                                        y="0px"
                                        viewBox="0 0 373.6 373.6"
                                        style="enable-background:new 0 0 373.6 373.6; fill:#1e90ff;"
                                        xml:space="preserve"
                                >
                  <g>
                    <g>
                      <path
                              d="M343.7,0H29.9c-5.5,0-10.1,4.9-10.1,10.5v64.2c0,0.3,0,0.6,0.1,1c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0.1,0.3,0.1,0.5    c0,0.2,0.1,0.3,0.1,0.5c0,0.1,0.1,0.3,0.1,0.4c0.1,0.2,0.1,0.4,0.2,0.5c0,0.1,0.1,0.2,0.1,0.4c0.1,0.2,0.1,0.3,0.2,0.5    c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0.2,0.2,0.3,0.2,0.4c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.2,0.3,0.3,0.4    c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.1,0.2,0.1,0.2,0.2l114.3,124.6v157.5c0,3.9,2.2,7.4,5.7,9.1c1.3,0.6,2.7,0.9,4.2,0.9    c2.4,0,4.7-0.8,6.5-2.4l80.2-68.3c2.2-1.9,3.5-4.7,3.4-7.6v-89.2L351,81.4c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.2,0.3-0.4    c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.2,0.2-0.3,0.3-0.4s0.2-0.3,0.2-0.4c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.2,0.2-0.4    c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1,0.1-0.2,0.1-0.4c0.1-0.2,0.1-0.3,0.2-0.5c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0.1-0.3,0.1-0.5    s0.1-0.3,0.1-0.5c0-0.1,0.1-0.3,0.1-0.4c0-0.3,0.1-0.6,0.1-1V10.4C353.8,4.9,349.3,0,343.7,0z M219.5,195.6    c-1.7,1.8-2.7,4.1-2.7,6.6v88.4l-60,51.3V202.2c0-2.5-1-4.8-2.7-6.6L52.6,85H321L219.5,195.6z M333.8,65h-294V20h294V65z"
                      />
                    </g>
                  </g>
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                                    <g />
                </svg>
                                {{$t('manageUser.clearFilter')}}
                            </div>
                        </td>
                    </template>
            </cTable>

             <!-- <button class="btn ml-auto btn-lit-blue mob-w100 btn-success ml-15 btn-sm">
             {{$t('fareUpload.importFareUpload')}}
            </button> -->
   
        </CCol>
        <CCardFooter >
          <div class="d-flex justify-content-between">
            <div>
              <CButton
                      @click="navigateToContract"
                      size="sm"
                      color="danger"
                      class="action-c-btn mr-15px"
              >{{ $t("fareUpload.goBack") }}</CButton>
            </div>
            <div class="d-flex">
              <button @click="toggleJsonExcelModal" class="btn ml-auto btn-lit-blue mob-w100 btn-success btn-sm">
                {{$t('fareUpload.downloadTemplate')}}
              </button>
              <upload-excel-component class="ml-10px" :on-success="handleSuccess" :before-upload="beforeUpload" />
            </div>


          </div>
          <div class="d-flex justify-content-end" v-if="alertValue" show color="danger">
            <div class="align-center d-flex">
              <CAlert v-if="alertValue" show color="danger" class=" d-flex">
                <div v-if="alertValue&&alertValue.hasOwnProperty('valueList')" class="d-flex ">
                  <p v-for="(value,index) in alertValue.valueList" :key="index">{{value}}</p>
                </div>
                <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')" class="ml-10px ">
                  <span>{{$t("cAlert.errorCode")+' : '}}</span>
                  <span v-for="(code,index) in alertValue.codeList" :key="index">{{code +' '}}</span>
                </div>
                <div v-if="alertValue&&alertValue.constructor==String" class="ml-10px ">
                  <p>{{alertValue}}</p>
                </div>
              </CAlert>
            </div>




          </div>
        </CCardFooter>

      </CCardBody>
    </CCard>

    
    <cAlertModal
      v-if="isDeleteFareConfirmation"
      :buttonList="[{
              name:$t('fareUpload.noBtn'),func:onHideConfirmationModals,color:'danger'},
                {name:$t('fareUpload.yesBtn'),func:onDeleteSchedule,color:'success'},]"
      :status="2"
      :show="isDeleteFareConfirmation"
      :desc="$t('fareUpload.deleteFareConfirmation')"
    ></cAlertModal>
   
    <cAlertModal
      v-if="isFlightFareDeleted"
      :buttonList="[{name:$t('fareUpload.okBtn'),func:onHideConfirmationModals,color:'success'}]"
      :status="1"
      :show="isFlightFareDeleted"
      :desc="$t('fareUpload.deleteFareSuccDesc')"
    ></cAlertModal>
    <cAlertModal
      v-if="isFailedModal"
      :buttonList="[{name:$t('fareUpload.okBtn'),func:onHideConfirmationModals,color:'danger'}]"
      :status="0"
      :show="isFailedModal"
      :desc="alertValue"
    ></cAlertModal>
  <cAlertModal
      v-if="isImported"
      :buttonList="[{name:$t('fareUpload.okBtn'),func:onHideConfirmationModals,color:'success'}]"
      :status="1"
      :show="isImported"
      :desc="$t('fareUpload.importSuccDesc')"
    ></cAlertModal>
    <cJsonExcelModal
      v-if="showJsonExcelModal "
      :show="showJsonExcelModal"
      :desc="$t('jsonExcelModal.desc', { name: $t('fareUpload.flightFares') })"
      :onCancel="toggleJsonExcelModal"
    >
      <template #jsonExcel>
        <div @click="toggleJsonExcelModal()">
          <cExportExcel
            :data="getPrintStatements()"
            :fields="getJsonExcelFields()"
            worksheet="Statements"
            :name="'FlightFare.xlsx'"
          >{{ $t("fareUpload.download") }}</cExportExcel>
        </div>
      </template>
    </cJsonExcelModal>


    <!-- {{tableData}}
    {{tableHeader}} -->
  
  </div>
</template>

<script>
import router, { navigate } from "../../../../router/index";
import cAlertModal from "../../../../components/form/cAlertModal";

import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS,
  ORDER
} from "../../../../util/constants";
import Logger from "../../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../../../config/API_DATA";

import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneData
} from "../../../../util/util";
import BaseConfiguration from "../../../../config/base.js";
import apiGetFlightFare from "../../../../services/apiGetFlightFare";
import apiDeleteFlightFare from "../../../../services/apiDeleteFlightFare";
import apiImportValidationFlightFare from "../../../../services/apiImportValidationFlightFare";
import apiImportFlightFare from "../../../../services/apiImportFlightFare";

// import cPaginationLenOption from "../../../../components/dataTable/cPaginationLenOption";
import cJsonExcelModal from "../../../../components/modal/cJsonExcelModal";
//import JsonExcel from "vue-json-excel";
import UploadExcelComponent from '../../../../components/excel/index.vue';
import cExportExcel from "../../../../components/excel/cExportExcel"
import Vue from 'vue';
// import cFullScreen from "../../../../components/cFullScreen"
// import cManageColumns from "../../../../components/dataTable/cManageColumns";
import cTable from "../../../../components/dataTable/cTable";

export default {
  name: COMPONENT_NAME.FARE_UPLOAD_ALL,
  components: {
    cAlertModal,
    cJsonExcelModal,
    cExportExcel,
    UploadExcelComponent,
    cTable
  },

  data: () => {
    return {
      alertValue: null,
       fareFilter:null,
      lsFlightFare: [],
      permission: null,
      flightFareTableWatchList: {
        filteredlistCount: null,
        itemsPerPage: 25,
        currentPageNum: 1
      },
     // fullscreen: false,
      isDeleteFareConfirmation: false,
      selectedFlightFare: null,
      isFailedModal: false,
      isFlightFareDeleted: false,
      showJsonExcelModal: false,
       tableData: [],
      tableHeader: [],
      isImported:false,
      isLoading:true,
      lsFlightFareFields:null
    };
  },

  methods: {
     ...mapActions("sFlightSchedule", {

                SET_SEL_FLIGHT_SCHEDULE: "SET_SEL_FLIGHT_SCHEDULE"
            }),
    // toggle() {
    //   this.$refs["fullscreen"].toggle(); // recommended
    //   // this.fullscreen = !this.fullscreen // deprecated
    // },
    // fullscreenChange(fullscreen) {
    //   this.fullscreen = fullscreen;
    // },

    saveFilterValue(pFareFilter) {
        try {
          if(BaseConfiguration.isDebug) console.log("saveFilterValue");
          this.fareFilter =pFareFilter
    
        } catch (err) {
                let body = Logger.buildRequest(
                   COMPONENT_NAME.FARE_UPLOAD_ALL,
                  "error in saveFilterValue",
                  err.toString(),
                  "saveFilterValue",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 
    
    clearAllFilters() {
        try {
          if(BaseConfiguration.isDebug) console.log("clearAllFilters");

          if(this.fareFilter )
          {
                    Object.keys(this.fareFilter).forEach(key=>{this.taxFilter[key]=""})

          }
         
    
        } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.FARE_UPLOAD_ALL,
                  "error in clearAllFilters",
                  err.toString(),
                  "clearAllFilters",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
        
        }, 
    
       onSaveColumns(pFields) {
    try {
      if(BaseConfiguration.isDebug) console.log("onSaveColumns");
      this.lsFlightFareFields=pFields;
      

    } catch (err) {
            let body = Logger.buildRequest(
             COMPONENT_NAME.FARE_UPLOAD_ALL,
              "error in onSaveColumns",
              err.toString(),
              "onSaveColumns",
              LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
          }
     
    }, 
             navigateToContract() {
      try {
      if (BaseConfiguration.isDebug) console.log("navigateToContract");
    
        navigate(PATHNAME.CONTRACT_ALL);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in navigateToContract",
          err.toString(),
          "navigateToContract",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
             navigateToFareUploadNew(pItem) {
      try {
      if (BaseConfiguration.isDebug) console.log("navigateToFareUploadNew");
      this.SET_SEL_FLIGHT_SCHEDULE(pItem);
        navigate(PATHNAME.FARE_UPLOAD_NEW);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in navigateToFareUploadNew",
          err.toString(),
          "navigateToFareUploadNew",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getJsonExcelFields() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getJsonExcelFields");
        let fields = {};

        fields[this.$t("fareUpload.from")] = "depcode";
        fields[this.$t("fareUpload.to")] = "arrcode";

        fields[this.$t("fareUpload.type")] = "fare_type";
        fields[this.$t("fareUpload.currency")] = "currency";
        fields[this.$t("fareUpload.fare")] = "basefare_amount";
        fields[this.$t("fareUpload.passengerType")] = "pax_type";
        fields[this.$t("fareUpload.class")] = "booking_class";
         fields[this.$t("fareUpload.cabinType")] = "cabin_type";

        fields[this.$t("fareUpload.maxSeats")] = "max_seats";
        fields[this.$t("fareUpload.fareRule")] = "ruleCode";
        fields[this.$t("fareUpload.airlineFareBasisCode")] =
          "airline_farebasis_code";
       

        retValue = cloneData(fields);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in getJsonExcelFields",
          err.toString(),
          "getJsonExcelFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    toggleJsonExcelModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleJsonExcelModal");

        this.showJsonExcelModal = !this.showJsonExcelModal;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in toggleJsonExcelModal",
          err.toString(),
          "toggleJsonExcelModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getPrintStatements() {
      let retValue = [];

      try {
        if (BaseConfiguration.isDebug) console.log("getPrintStatements");
 
         let lsFlightFare=[];
        if(this.lsFlightFare.length>0){
         lsFlightFare = JSON.parse(
          JSON.stringify(this.lsFlightFare)
        );
        }else{
          let flightFareObj=[{
            airline_farebasis_code:"12",
            arrcode:"MDL",
            basefare_amount:"12.00",
            booking_class:"C",
            cabin_type:"BUSINESS",
            currency:"USD",
            depcode:"RGN",
            fare_type:"OW",
            fareid:"15",
            isactive:true,
            max_seats:12,
            pax_type:"ADT",
            ruleCode:"Test6",
            ruleId:"41"
          }]
         lsFlightFare = JSON.parse(
          JSON.stringify(flightFareObj)
        );
        }
       

        retValue = cloneData(lsFlightFare);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in getPrintStatements",
          err.toString(),
          "getPrintStatements",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
   

    showDeleteFareModal(pItem) {
      try {
        if (BaseConfiguration.isDebug) console.log("showDeleteFareModal");
        this.selectedFlightFare = pItem;
        this.isDeleteFareConfirmation = true;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in showDeleteFareModal",
          err.toString(),
          "showDeleteFareModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onHideConfirmationModals() {
      try {
        if (BaseConfiguration.isDebug) console.log("onHideConfirmationModals");

        this.isDeleteFareConfirmation = false;
        this.isFailedModal = false;
        this.isFlightFareDeleted = false;
        this.isImported=false;
        this.alertValue=null;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in onHideConfirmationModals",
          err.toString(),
          "onHideConfirmationModals",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPaginationChange(pItemsPerPage) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPaginationChange");
        this.flightFareTableWatchList.itemsPerPage = pItemsPerPage;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in onPaginationChange",
          err.toString(),
          "onPaginationChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onPageChange(pPageNum) {
      try {
        if (BaseConfiguration.isDebug) console.log("onPageChange");
        this.flightFareTableWatchList.currentPageNum = pPageNum;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in onPageChange",
          err.toString(),
          "onPageChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getFilteredFlightFareCount(pFilteredItems) {
      try {
        if (BaseConfiguration.isDebug)
          console.log("getFilteredFlightFareCount");
        this.flightFareTableWatchList.filteredlistCount =
          pFilteredItems.length;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in getFilteredFlightFareCount",
          err.toString(),
          "getFilteredFlightFareCount",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getFareUploadFields() {
      let returnValue = [];
      try {
        let lsFields = [
          {
            key: "depcode",
            label: this.$t("fareUpload.from"),
            isLocked:true
          },

          {
            key: "arrcode",
            label: this.$t("fareUpload.to"),
            isLocked:true
          },

          {
            key: "fare_type",
            label: this.$t("fareUpload.type"),
            isLocked: false
          },
       {
            key: "currency",
            label: this.$t("fareUpload.currency"),
            isLocked: false
          },
          {
            key: "basefare_amount",
            label: this.$t("fareUpload.fare"),
            isLocked:false
          },
          {
            key: "pax_type",
            label: this.$t("fareUpload.passengerType"),
            isLocked: false
          },
          {
            key: "booking_class",
            label: this.$t("fareUpload.class"),
            isLocked: false
          },
           {
            key: "cabin_type",
            label: this.$t("fareUpload.cabinType"),
            isLocked: false
          },
          {
            key: "max_seats",
            label: this.$t("fareUpload.maxSeats"),
            isLocked:false
          },
          {
            key: "ruleCode",
            label: this.$t("fareUpload.fareRule"),
            isLocked:true
          },

          {
            key: "airline_farebasis_code",
            label: this.$t("fareUpload.airlineFareBasisCode"),
            isLocked:false
          },
          
          {
            key: "actions",
            label: this.$t("fareUpload.actions"),
            sorter: false,
            filter: false,
            isLocked:false
          }
        ];

        returnValue = lsFields;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in getFareUploadFields",
          err.toString(),
          "getFareUploadFields",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return returnValue;
    },

   
    async onDeleteSchedule() {
      try {
        if (BaseConfiguration.isDebug) console.log("onDeleteSchedule");
 let fareid =
          this.selectedFlightFare && this.selectedFlightFare.fareid
            ? this.selectedFlightFare.fareid
            : null;
        this.isDeleteFareConfirmation = false;

        let isDeleted = await this.deleteFlightSchedule(fareid);
        if (isDeleted) {
          let lsFlightFare = await this.getFlightFare();
          if (lsFlightFare) {
            this.lsFlightFare = lsFlightFare;
          }
          this.isFlightFareDeleted = true;
        } else {
          this.isFailedModal = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in onDeleteSchedule",
          err.toString(),
          "onDeleteSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    
    async deleteFlightSchedule(pFareid) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("deleteFlightSchedule");

        let flightFareReq = apiDeleteFlightFare.buildRequest(
          pFareid
        );

        if (flightFareReq) {
          let flightFareRes = await apiDeleteFlightFare.getResponse(
            flightFareReq
          );
          if (VALIDATE_SUCCESS_RES(flightFareRes)) {
               this.alertValue=null;
            retValue = flightFareRes.data.data.isDeleted;
            // this.showAcknowledgeAlert();
          } else {
            let error = getErrorMessage(flightFareRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in deleteFlightSchedule",
          err.toString(),
          "deleteFlightSchedule",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async getFlightFare() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getFlightFare");
        let contractId=this.GET_SELECTED_CONTRACT?this.GET_SELECTED_CONTRACT.contractid:null;
        let flightFareReq = apiGetFlightFare.buildRequest(contractId);

        if (flightFareReq) {
          let flightFareRes = await apiGetFlightFare.getResponse(
            flightFareReq
          );
          if (VALIDATE_SUCCESS_RES(flightFareRes)) {
                        this.alertValue=null;

            retValue = flightFareRes.data.data.FlightFareList;
            this.permission = flightFareRes.data.data.permission;
            // this.showAcknowledgeAlert();
          } else {
            let error = getErrorMessage(flightFareRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in getFlightFare",
          err.toString(),
          "getFlightFare",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1
      if (isLt1M) {
        return true
      }
      this.$dialog.confirm('<stong>Please do not upload files larger than 1MB in size. </stong><div></div>')                    
                    .then(function (dialog) {
                        //OK handler
                    })
                    .catch(function () {
                        //log
                    });
      
      return false
    },

    async getValidationForImportFF(pReqBody) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getValidationForImportFF");
        let flightFareReq = apiImportValidationFlightFare.buildRequest(pReqBody);

        if (flightFareReq) {
          let flightFareRes = await apiImportValidationFlightFare.getResponse(
            flightFareReq
          );
          if (VALIDATE_SUCCESS_RES(flightFareRes)) {
                        this.alertValue=null;

            retValue = flightFareRes.data.data;
         
            // this.showAcknowledgeAlert();
          } else {
            let error = getErrorMessage(flightFareRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in getValidationForImportFF",
          err.toString(),
          "getValidationForImportFF",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

       async getImportFlightFare(pReqBody) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getImportFlightFare");
        let flightFareReq = apiImportFlightFare.buildRequest(pReqBody);

        if (flightFareReq) {
          let flightFareRes = await apiImportFlightFare.getResponse(
            flightFareReq
          );
          if (VALIDATE_SUCCESS_RES(flightFareRes)) {
                        this.alertValue=null;

            retValue = flightFareRes.data.data;
         
            // this.showAcknowledgeAlert();
          } else {
            let error = getErrorMessage(flightFareRes);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error,true,true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.FARE_UPLOAD_ALL,
          "error in getImportFlightFare",
          err.toString(),
          "getImportFlightFare",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    formatImportedXlValues(pTableData) {
       let retValue=[];
       try {
          if(BaseConfiguration.isDebug) console.log("formatImportedXlValues");

        for(let i=0;i<pTableData.length;i++){
  //         let data={
  //             "fareid":Number(this.lsFlightFare[i].fareid),
  //   "contract" :this.GET_SELECTED_CONTRACT?Number(this.GET_SELECTED_CONTRACT.contractid):null,
  //   "depcode": this.lsFlightFare[i].depcode,
  //   "arrcode": this.lsFlightFare[i].arrcode,
  //   "currency": this.lsFlightFare[i].currency,
  //   "fare_type":  this.lsFlightFare[i].fare_type,
  //  "cabin_type": this.lsFlightFare[i].cabin_type,
  //   "pax_type":  this.lsFlightFare[i].pax_type,
  //   "basefare_amount":  Number(this.lsFlightFare[i].basefare_amount),
  //   "booking_class": this.lsFlightFare[i].booking_class,
  //   "airline_farebasis_code":this.lsFlightFare[i].airline_farebasis_code,
    
  //   "ruleCode":this.lsFlightFare[i].ruleCode,
  //       "max_seats":Number(this.lsFlightFare[i].max_seats)
  //         }
         let data=
         {
	  //  "fareid":Number(this.lsFlightFare[i].fareid),
    "contract" :this.GET_SELECTED_CONTRACT?Number(this.GET_SELECTED_CONTRACT.contractid):null,
    "depcode": pTableData[i]['From'],
    "arrcode": pTableData[i]['To'],
    "currency": pTableData[i]['Currency'],
    "fare_type":  pTableData[i]['Type'],
  "cabin_type":  pTableData[i]['Cabin Type'],
    "pax_type":  pTableData[i]['Passenger Type'],
    "basefare_amount":  Number(pTableData[i]['Fare']),
    "booking_class": pTableData[i]['Class'],
    "airline_farebasis_code":pTableData[i]['Airline Farebasis Code'],
    
    "ruleCode":pTableData[i]['Fare Rule'],
        "max_seats":pTableData[i]['Maximum Seats']?Number(pTableData[i]['Maximum Seats']):0

}

     
        retValue.push(data)
        }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_UPLOAD_ALL,
                  "error in formatImportedXlValues",
                  err.toString(),
                  "formatImportedXlValues",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

        
   async handleSuccess({ results, header }) {
     try{
                 if(BaseConfiguration.isDebug) console.log("handleSuccess");

      this.tableData = results
      this.tableHeader = header
        let options = {
    html: true, 
    loader: true, 
    okText: 'Continue',
    cancelText: 'Close',
    animation: 'bounce',
   
};
let that=this;
         this.$dialog.confirm('<stong>Click continue to validate</stong><div></div>',options)                    
                    .then( function  (dialog) {

 setTimeout(async() => {
           let retFormattedFares= that.formatImportedXlValues(that.tableData);
     dialog.close();
      let retValue= await that.getValidationForImportFF(retFormattedFares);
      
      if(retValue&&retValue.isAllValid){//retValue&&retValue.isAllValid
        // dialog.close();
        //  that.$dialog.confirm('<stong>Validated.Are you sure want to Upload file?</stong><div></div>',options)                    
        //             .then(async function  (dialog) {
                              let retFormattedFares= that.formatImportedXlValues(that.tableData);

                    let retImportValue= await that.getImportFlightFare(retFormattedFares);
                     if(retImportValue&&retImportValue.isImported){
                       
                        that.isImported=true;
                         let lsFlightFare = await that.getFlightFare();
      if (lsFlightFare) {
        that.lsFlightFare = lsFlightFare;
      }
   
                     }
                    //       })
                    // .catch(function () {
                    //     //log
                        
                    // }); 
      }else{
         dialog.close();
         let retErrList=that.getErrorFromFareList(retValue.list);
         if(retErrList.length>0){
         that.alertValue=retErrList;
         }else{
         that.alertValue=that.$t("fareUpload.invalidExcelFormat");
         }
         that.isFailedModal=true;

          // that.$dialog.confirm('<stong>Validation failed.</stong><div></div>',options)
          //           .then( function  (dialog) {
          //                 })
          //           .catch(function () {
          //               //log
                        
          //           });
      }
    },1000 );
  
         
                   
     
                    })
                    .catch(function () {
                        //log
                        
                    }); 
     }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_UPLOAD_ALL,
                  "error in handleSuccess",
                  err.toString(),
                  "handleSuccess",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
     
    },
    getErrorFromFareList(pFareList) {
      let retValue=[];
        try {
          if(BaseConfiguration.isDebug) console.log("getErrorValue");
         
               pFareList.forEach(item => {
                 if(item.error&&item.error.length>0){
                   item.error.forEach(err =>{
                  retValue.push(err);
                   });
                 }
               });
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.FARE_UPLOAD_ALL,
                  "error in getErrorValue",
                  err.toString(),
                  "getErrorValue",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
  
  },

  async created() {
    try {
      this.lsFlightFareFields=this.getFareUploadFields();
      let lsFlightFare = await this.getFlightFare();
      if (lsFlightFare) {
        this.lsFlightFare = lsFlightFare;
      }
      this.isLoading=false;
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.FARE_UPLOAD_ALL,
        "error in  Created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },
 computed: {
    ...mapGetters("sContract", {
      GET_SELECTED_CONTRACT: "GET_SELECTED_CONTRACT"
    }),
  },
  beforeCreate() {
    addClassToBody(COMPONENT_NAME.FARE_UPLOAD_ALL);
  },

  beforeDestroy() {
    removeClassBody();
  }
};
</script>
<style >
/* .setting-t-t{
  display: contents;
} */

</style>